import { render, staticRenderFns } from "./orderConfirmed.vue?vue&type=template&id=a5c1b068"
import script from "./orderConfirmed.vue?vue&type=script&lang=js"
export * from "./orderConfirmed.vue?vue&type=script&lang=js"
import style0 from "./orderConfirmed.vue?vue&type=style&index=0&id=a5c1b068&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports